import logo from "./logo.svg";
import "./App.css";
import "antd/dist/antd.css";
import LatestWeekly from "./components/LatestWeekly";
import LatestMonthly from "./components/LatestMonthly";
import EditPage from "./components/EditPage";
import MarkdownEditPage from "./components/MarkdownEditPage";
import MarkdownPage from "./components/MarkdownPage";
import ReadList from "./components/ReadList";
import ShowPage from "./components/ShowPage";
import SignInPage from "./components/SignInPage";
import LifeSection from "./components/LifeSection";
import FoodLogPage from "./components/FoodLogPage";
import ProtectedRoute from "./components/ProtectedRoute";
import EmailAnalysisList from "./components/EmailAnalysisList";
import LocationHistory from "./components/LocationHistory";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation,
  Redirect,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, Layout } from "antd";
import ChineseCalendar from "./components/ChineseCalendar";
import {
  BookOutlined,
  UserOutlined,
  AimOutlined,
  EditOutlined,
  FolderViewOutlined,
  HeartOutlined,
  SafetyCertificateOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import ReadSummaryList from "./components/ReadSummaryList";
const { Header, Sider, Content } = Layout;
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const { SubMenu } = Menu;
function App(props) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setIsAuthenticated(authToken !== null);
  }, []);
  const sub = [
    { name: "每周计划", json: "weekly_2026" },
    { name: "每周工作总结", json: "weekly_work" },
    { name: "每周生活时间总结", json: "weekly_analysis" },
    { name: "每月计划", json: "monthly" },
    { name: "提醒自己", json: "reminder_list" },
    { name: "故事", json: "story" },
    { name: "笑话", json: "fun" },
    { name: "自己的想法", json: "event_and_feeling" },
  ];
  const todo_list = [
    { name: "视频上传清单", json: "video_upload_checklist" },
    { name: "读书计划", json: "book" },
    { name: "做饭", json: "cook" },
    { name: "旅游", json: "tour" },
    { name: "摄影", json: "photos" },
    { name: "想做的事情", json: "play" },
  ];
  let query = useQuery();
  return (
    <Layout>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
      >
        <div className="logo" />
        <Menu theme="dark" mode="inline" defaultSelectedKeys={["1"]}>
          <Menu.Item key="signin" icon={<UserOutlined />}>
            Sign In
            <Link to="/signin" />
          </Menu.Item>
          <Menu.Item key="1" icon={<UserOutlined />}>
            自己提高的点
            <Link to="/improvement" />
          </Menu.Item>
          <Menu.Item key="life" icon={<AimOutlined />}>
            人生系统模型
            <Link to="/life" />
          </Menu.Item>
          <Menu.Item key="10" icon={<UserOutlined />}>
            原则
            <Link to="/principe" />
          </Menu.Item>
          <Menu.Item key="11" icon={<HeartOutlined />}>
            同理心
            <Link to="/empthy" />
          </Menu.Item>
          <Menu.Item key="12" icon={<SafetyCertificateOutlined />}>
            应急处理
            <Link to="/safety" />
          </Menu.Item>
          <Menu.Item key="location" icon={<EnvironmentOutlined />}>
            位置历史
            <Link to="/location" />
          </Menu.Item>
          <Menu.Item key="2" icon={<AimOutlined />}>
            本周目标
            <Link to="/weekly" />
          </Menu.Item>
          <Menu.Item key="3" icon={<AimOutlined />}>
            本月目标
            <Link to="/monthly" />
          </Menu.Item>
          <Menu.Item key="4" icon={<AimOutlined />}>
            年计划
            <Link to="/year_plan" />
          </Menu.Item>
          <Menu.Item key="calendar" icon={<CalendarOutlined />}>
            干支日历
            <Link to="/chinese-calendar" />
          </Menu.Item>
          <Menu.Item key="5" icon={<BookOutlined />}>
            读书笔记
            <Link to="/read" />
          </Menu.Item>
          <Menu.Item key="6" icon={<BookOutlined />}>
            书籍总结
            <Link to="/book_summary" />
          </Menu.Item>
          <SubMenu key="email" icon={<BookOutlined />} title="email">
            <Menu.Item key="7">
              email总结
              <Link to="/email_analysis" />
            </Menu.Item>
            <Menu.Item key="8">
              重要事项
              <Link to="/email_important" />
            </Menu.Item>
          </SubMenu>
          <SubMenu key="sub1" icon={<EditOutlined />} title="修改">
            {sub.map((item) => {
              const key = `${item.json}_edit`;
              return (
                <Menu.Item key={key}>
                  {item.name}
                  <Link to={`/${key}`} />
                </Menu.Item>
              );
            })}
          </SubMenu>
          <SubMenu key="sub2" icon={<FolderViewOutlined />} title="查看">
            {sub.map((item) => {
              const key = `${item.json}_view`;
              return (
                <Menu.Item key={key}>
                  {item.name}
                  <Link to={`/${key}`} />
                </Menu.Item>
              );
            })}
          </SubMenu>
          <SubMenu key="sub3" icon={<EditOutlined />} title="添加清单">
            {todo_list.map((item) => {
              const key = `${item.json}_edit`;
              return (
                <Menu.Item key={key}>
                  {item.name}
                  <Link to={`/${key}`} />
                </Menu.Item>
              );
            })}
          </SubMenu>
          <SubMenu key="sub4" icon={<FolderViewOutlined />} title="查看清单">
            {todo_list.map((item) => {
              const key = `${item.json}_view`;
              return (
                <Menu.Item key={key}>
                  {item.name}
                  <Link to={`/${key}`} />
                </Menu.Item>
              );
            })}
          </SubMenu>
        </Menu>
      </Sider>
      <Layout>
        <Header
          className="site-layout-sub-header-background"
          style={{ padding: 0 }}
        />
        <Content style={{ margin: "24px 16px 0" }}>
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 1024 }}
          >
            <ProtectedRoute
              exact
              path="/"
              component={() => (
                <MarkdownPage name="我能做的好的地方.md" list="must" />
              )}
            />
            <ProtectedRoute
              path="/improvement"
              component={() => (
                <MarkdownPage name="我能做的好的地方.md" list="must" />
              )}
            />
            <ProtectedRoute
              path="/safety"
              component={() => (
                <MarkdownPage name="应急处理方法.md" list="must" />
              )}
            />
            <ProtectedRoute
              path="/year_plan"
              component={() => (
                <MarkdownPage name="2026年计划.md" list="must" />
              )}
            />
            <ProtectedRoute path="/weekly" component={LatestWeekly} />
            <ProtectedRoute path="/monthly" component={LatestMonthly} />
            <ProtectedRoute path="/read" component={ReadList} />
            <ProtectedRoute path="/book_summary" component={ReadSummaryList} />
            <ProtectedRoute
              path="/email_analysis"
              component={() => (
                <EmailAnalysisList
                  listName="email_analysis"
                  pageTitle="邮件分析"
                />
              )}
            />
            <ProtectedRoute
              path="/email_important"
              component={() => (
                <EmailAnalysisList
                  listName="important"
                  pageTitle="重要事项"
                />
              )}
            />
            {sub.map((item) => {
              const key = `/${item.json}_edit`;

              return (
                <ProtectedRoute
                  path={key}
                  children={
                    <EditPage list={item.json} date={query.get("date") ?? ""} />
                  }
                />
              );
            })}
            {sub.map((item) => {
              const key = `/${item.json}_view`;
              return (
                <ProtectedRoute
                  path={key}
                  children={<ShowPage list={item.json} />}
                />
              );
            })}
            {todo_list.map((item) => {
              const key = `/${item.json}_edit`;

              return (
                <ProtectedRoute
                  path={key}
                  children={
                    <EditPage list={item.json} date={query.get("date") ?? ""} />
                  }
                />
              );
            })}
            {todo_list.map((item) => {
              const key = `/${item.json}_view`;
              return (
                <ProtectedRoute
                  path={key}
                  children={<ShowPage list={item.json} />}
                />
              );
            })}
            <Route
              path="/markdown_edit"
              children={
                <MarkdownEditPage
                  list={query.get("list") ?? ""}
                  name={query.get("name") ?? ""}
                />
              }
            />
            <Route
              path="/markdown_show"
              children={
                <MarkdownPage
                  list={query.get("list") ?? ""}
                  name={query.get("name") ?? ""}
                />
              }
            />
            <ProtectedRoute path="/life" component={LifeSection} />
            <ProtectedRoute path="/location" component={LocationHistory} />
            <ProtectedRoute path="/food" component={FoodLogPage} />
            <ProtectedRoute
              path="/principe"
              children={<MarkdownPage name="原则.md" list="must" />}
            />
            <ProtectedRoute
              path="/empthy"
              children={<MarkdownPage name="同理心.md" list="must" />}
            />
            <Route path="/signin" component={SignInPage} />
            <Route path="/chinese-calendar" component={ChineseCalendar} />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
